import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import lo from 'lodash'

import { actionFormatter } from 'molecules/TableFormatters'
import { selectionFormatter } from 'molecules/TableFormatters/selectionFormatter'
import DataTable from 'organisms/DataTable'
import OutpitWorkModal from 'components/organisms/OutpitWorkModal'
import ModalPage from 'templates/ModalPage/index'
import { OUTPIT_WORK_VALIDATIONS } from 'fixtures/api'
import {
  TxtSuccessSubmit,
  TxtFailedSubmitData,
  TxtConfirmDeleteReport,
  TxtSuccessDeleteReport,
  TxtFailedDelete,
} from 'fixtures/texts'
import { getAllCompaniesData } from 'Redux/actions/CompanyListActions'
import { getLookup } from 'Redux/actions/LookupActions'
import { toggleIsLoading } from 'Redux/actions/ViewStateActions'
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions'
import { deleteData, postNewData, putData } from 'services/cmsService'
import { TableWrapper } from './styles'
import FormCheck from 'components/atoms/Inputs/FormCheck'
import { permissionCheck } from 'helpers/permissionCheckHelper'
import { outpitWorkDelete, outpitWorkUpdate } from 'fixtures/permissions'

class OutpitWorkValidation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: lo.cloneDeep(props.data),
      allowUpdate: permissionCheck(props.user.permissions, outpitWorkUpdate),
      allowDelete: permissionCheck(props.user.permissions, outpitWorkDelete),
      isShowModal: false,
      navList: ['Outpit Work Validation'],
      modalData: {},
      isSubmitDisabled: false,
      isError: { status: false, msg: '' },
    }
  }

  componentDidMount() {
    this.props.onRef(this)
    this.props.getAllCompaniesData()
    this.props.getLookup('OUTPIT_WORK', 'OUTPIT_WORK_TYPE')
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props
    if (!lo.isEqual(prevProps.data, data)) {
      this.setState({ data })
    }
  }

  switchModal(row) {
    const { isShowModal } = this.state
    this.setState(
      {
        modalData: row
          ? {
              id: row.id,
              companyId: row.companyId,
              contractorId: row.contractorId,
              shiftId: row.shiftId,
              date: row.date ? new Date(row.date) : new Date(),
              startWorkingTime: this.convertStringToMilliseconds(
                row.date,
                row.workingTimeStart
              ),
              endWorkingTime: this.convertStringToMilliseconds(
                row.date,
                row.workingTimeStop
              ),
              workTypeName: row.workType,
              block: row.block,
              locationSection: row.locationSection,
              locationElevation: row.locationElevation,
              excavator: row.equipmentExcavator,
              buldozer: row.equipmentBulldozer,
              dumpTruck: row.equipmentDumpTruck,
              dumpTruckAmount: row.equipmentDumpTruckAmount,
              ritase: row.ritase,
              volume: row.volume,
              materialType: row.materialType,
              dumpingDestination: row.dumpingDestination,
              dumpingDistance: row.dumpingDistance,
              remark: row.remark,
            }
          : {},
      },
      () => {
        this.setState({ isShowModal: !isShowModal })
      }
    )
  }

  addNew = () => {
    const { isShowModal } = this.state
    this.setState({
      isShowModal: !isShowModal,
      modalData: {
        companyId: 2,
        contractorId: 2,
        shiftId: 3,
        date: new Date(),
        startWorkingTime: 1691974800450,
        endWorkingTime: 1692007200450,
        workTypeName: 'Void Management',
        block: 0,
        locationSection: null,
        locationElevation: 0,
        excavator: null,
        buldozer: null,
        dumpTruck: null,
        dumpTruckAmount: 0,
        ritase: 0,
        volume: 0,
        materialType: null,
        dumpingDestination: null,
        dumpingDistance: 0,
        remark: null,
      },
    })
  }

  convertStringToMilliseconds = (stringDate, stringTime) => {
    if (stringDate && stringTime) {
      const splitStringDate = stringDate.split('-')
      const splitStringTime = stringTime.split(':')
      const date = new Date(
        splitStringDate[0],
        splitStringDate[1],
        splitStringDate[2],
        splitStringTime[0],
        splitStringTime[1],
        splitStringTime[2]
      )
      return date.getTime()
    } else return null
  }

  toggleChecklist = (row, field) => {
    const { data } = this.state
    const newData = data.map((d) =>
      d.id === row.id ? { ...d, [field]: !row[field] } : d
    )
    this.setState({ data: newData })
    this.props.onChecked(row.id)
  }

  toggleAllChecklist = () => {
    const { data } = this.state
    const { isCheckedAll } = this.props
    const newData = data.map((d) => ({ ...d, isChecked: !isCheckedAll }))
    this.setState({ data: newData })
    this.props.onAllChecked(!isCheckedAll ? newData.map((d) => d.id) : [])
  }

  onChangeModalData = (val, field) => {
    const { modalData } = this.state
    modalData[field] = val
    this.setState({ modalData })
  }

  onSubmit = () => {
    const { modalData } = this.state
    const {
      id,
      companyId,
      contractorId,
      shiftId,
      date,
      startWorkingTime,
      endWorkingTime,
      workTypeName,
      block,
      locationElevation,
      locationSection,
      excavator,
      buldozer,
      dumpTruck,
      dumpTruckAmount,
      ritase,
      volume,
      materialType,
      dumpingDestination,
      dumpingDistance,
      remark,
    } = modalData

    const uri = id
      ? `${OUTPIT_WORK_VALIDATIONS}/${id}`
      : OUTPIT_WORK_VALIDATIONS

    const form = {
      companyId,
      contractorId,
      shiftId,
      date: moment(date).format('YYYY-MM-DD'),
      workingTimeStart: moment(startWorkingTime).format('h:mm:ss'),
      workingTimeStop: moment(endWorkingTime).format('h:mm:ss'),
      workType: workTypeName,
      block: parseInt(block),
      locationElevation:
        locationElevation || locationElevation === 0
          ? parseFloat(locationElevation)
          : null,
      locationSection,
      equipmentExcavator: excavator,
      equipmentBulldozer: buldozer,
      equipmentDumpTruck: dumpTruck,
      equipmentDumpTruckAmount: parseInt(dumpTruckAmount),
      ritase: parseInt(ritase),
      volume: parseFloat(volume),
      materialType,
      dumpingDestination,
      dumpingDistance,
      remark,
    }

    this.setState({ isSubmitDisabled: true }, async () => {
      try {
        const res = id ? await putData(uri, form) : await postNewData(uri, form)
        if (res.status >= 200 && res.status < 300) {
          alert(TxtSuccessSubmit)
          this.props.onRefresh()
          this.setState({
            isShowModal: false,
            modalData: {},
          })
        }
      } catch (error) {
        alert(TxtFailedSubmitData)
      } finally {
        this.setState({ isSubmitDisabled: false })
      }
    })
  }

  onDelete = async (data) => {
    const isOk = window.confirm(TxtConfirmDeleteReport)
    if (isOk) {
      const url = `${OUTPIT_WORK_VALIDATIONS}/${data.id}`
      try {
        const res = await deleteData(url)
        if (res.status !== 500) {
          alert(TxtSuccessDeleteReport)
          this.props.onRefresh()
        } else {
          throw res
        }
      } catch (error) {
        alert(TxtFailedDelete)
      }
    }
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[this.state.navList[0]] = size
    setLocalSettingsTableData(settings)
  }

  render() {
    const {
      settingsTable,
      viewState: { isMobileView },
      isCheckedAll,
    } = this.props
    const { data, isShowModal, modalData, isSubmitDisabled, isError, navList } =
      this.state

    const sizePerPage = settingsTable.sizePerPage[navList[0]]
    const isContractor =
      this.props.user.userRole === 'CONTRACTOR' ||
      String(this.props.user.department.name)
        .toLowerCase()
        .includes('contractor')

    const columnConfig = [
      {
        dataField: 'id',
        text: '',
        sort: false,
        headerFormatter: () => (
          <FormCheck
            value={isCheckedAll}
            allowEdit={data && data.length > 0}
            fn={() => this.toggleAllChecklist()}
          />
        ),
        formatter: (cell, row, rowIndex, formatExtraData) =>
          isContractor && row.validatedAt
            ? null
            : selectionFormatter(cell, row, rowIndex, formatExtraData),
        formatExtraData: {
          allowEdit: true,
          field: 'isChecked',
          fn: (row, field) => this.toggleChecklist(row, field),
        },
        headerAttrs: { width: isMobileView ? 200 : 500 },
        headerAlign: 'center',
        align: 'center',
        editable: false,
        isDummyField: true,
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerAttrs: { width: isMobileView ? 100 : 150 },
        headerStyle: { minWidth: '75px' },
        formatter: actionFormatter,
        formatExtraData: {
          style: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          },
          allowEdit: this.state.allowUpdate,
          allowDel: this.state.allowDelete,
          isContractor,
          edit: (row) => this.switchModal.bind(this, row),
          del: (row) => this.onDelete.bind(this, row),
        },
        isDummyField: true,
      },
      {
        dataField: 'company.name',
        text: 'Company',
        headerStyle: { minWidth: '100px' },
        sort: true,
      },
      {
        dataField: 'contractor.name',
        text: 'Contractor',
        sort: true,
      },
      {
        dataField: 'shift.name',
        text: 'Shift',
        headerStyle: { minWidth: '80px' },
        sort: true,
      },
      {
        dataField: 'date',
        text: 'Date',
        headerStyle: { minWidth: '100px' },
        formatter: (cell) => moment(cell).format('YYYY-MM-DD'),
        sort: true,
      },
      {
        dataField: 'block',
        text: 'Block',
        headerStyle: { minWidth: '50px' },
        sort: true,
      },
      {
        dataField: 'workType',
        text: 'Work Type',
        headerStyle: { minWidth: '150px' },
        sort: true,
      },
      {
        dataField: 'locationSection',
        text: 'Location Section',
        headerStyle: { minWidth: '150px' },
        sort: true,
      },
      {
        dataField: 'locationElevation',
        text: 'Location Elevation',
        headerStyle: { minWidth: '150px' },
        sort: true,
      },
      {
        dataField: 'equipmentExcavator',
        text: 'Excavator',
        headerStyle: { minWidth: '100px' },
        sort: true,
      },
      {
        dataField: 'equipmentBulldozer',
        text: 'Bulldozer',
        headerStyle: { minWidth: '100px' },
        sort: true,
      },

      {
        dataField: 'equipmentDumpTruck',
        text: 'Dump Truck Name',
        headerStyle: { minWidth: '160px' },
        sort: true,
      },
      {
        dataField: 'equipmentDumpTruckAmount',
        text: 'Dump Truck Amount',
        headerStyle: { minWidth: '180px' },
        sort: true,
      },
      {
        dataField: 'ritase',
        text: 'Ritase',
        headerStyle: { minWidth: '50px' },
        sort: true,
      },
      {
        dataField: 'volume',
        text: 'Volume',
        headerStyle: { minWidth: '100px' },
        sort: true,
      },
      {
        dataField: 'materialType',
        text: 'Material Type',
        headerStyle: { minWidth: '150px' },
        sort: true,
      },
      {
        dataField: 'dumpingDestination',
        text: 'Dumping Destination',
        headerStyle: { minWidth: '200px' },
        sort: true,
      },
      {
        dataField: 'dumpingDistance',
        text: 'Dumping Distance',
        headerStyle: { minWidth: '150px' },
        sort: true,
      },
      {
        dataField: 'remark',
        text: 'Remark',
        headerStyle: { minWidth: '150px' },
        sort: true,
      },
      {
        dataField: 'validatedAt',
        text: 'Validated At',
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return (
            <div>
              {row.validatedAt
                ? moment(row.validatedAt).format('DD/MM/YYYY - h:mm A')
                : '-'}
            </div>
          )
        },
        headerStyle: { minWidth: '200px' },
        headerAlign: 'center',
        align: 'center',
        sort: true,
      },
      {
        dataField: 'validatedBy',
        text: 'Validated By',
        headerStyle: { minWidth: '150px' },
        headerAlign: 'center',
        align: 'center',
        sort: true,
      },
      {
        dataField: 'mmStatus',
        text: 'MM Status',
        headerStyle: { minWidth: '150px' },
        sort: true,
        headerAlign: 'center',
        align: 'center',
        formatter: (cell) => {
          return cell ? cell : '-'
        },
      },
      {
        dataField: 'mmRemark',
        text: 'MM Remarks',
        headerStyle: { minWidth: '350px' },
        sort: true,
      },
    ]

    return (
      <>
        <TableWrapper>
          <DataTable
            isMobile={isMobileView}
            fnEdit={this.fnEdit}
            dataList={data}
            columnConfig={columnConfig}
            containerClassName="p-0"
            wrapperClasses="table-responsive"
            isInlineEdit
            sizePerPage={sizePerPage}
            onSizePerPageChange={this.onSizePerPageChange}
          />
        </TableWrapper>

        <ModalPage
          isOpen={isShowModal}
          fnSwitch={this.switchModal.bind(this)}
          contentChild={
            <OutpitWorkModal
              fnChange={this.onChangeModalData.bind(this)}
              fnSubmit={this.onSubmit.bind(this)}
              fnSwitch={this.switchModal.bind(this)}
              outpitWorkData={modalData}
              isDisabled={isSubmitDisabled}
              isError={isError}
              isMobileView={isMobileView}
              {...this.props}
            />
          }
        />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
    companiesList: state.companiesList,
    worktypeList:
      state.lookups.data && 'OUTPIT_WORK' in state.lookups.data
        ? state.lookups.data['OUTPIT_WORK']['OUTPIT_WORK_TYPE']
        : [],
    settingsTable: state.settingsTable,
    user: state.userLogin ? state.userLogin.userDetail : {},
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleIsLoading,
      getAllCompaniesData,
      getLookup,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OutpitWorkValidation)
